import { createAsyncThunk } from '@reduxjs/toolkit'
import { eventPostsAPI } from 'src/api/event-posts'
import { IEventPostParams } from 'src/interfaces/event-posts'

export const getListEventPostsAction = createAsyncThunk(
  'eventPosts/getListEventPostsAction',
  async ({ limit = 10, ...otherParams }: IEventPostParams) => {
    try {
      const res = await eventPostsAPI.getListEventPosts({
        limit,
        ...otherParams,
      })
      return res
    } catch (error) {
      throw error
    }
  }
)

export const getEventPostDetailAction = createAsyncThunk(
  'eventPosts/getEventPostDetailAction',
  async (eventId: string) => {
    try {
      const res = await eventPostsAPI.getEventPostDetail(eventId)
      return res
    } catch (error) {
      throw error
    }
  }
)

export const createEventPostAction = createAsyncThunk(
  'eventPosts/createEventPostAction',
  async (params: any) => {
    try {
      const res = await eventPostsAPI.createEventPost(params)
      return res
    } catch (error) {
      throw error
    }
  }
)

export const updateEventPostAction = createAsyncThunk(
  'eventPosts/updateEventPostAction',
  async ({ eventId, params }: { eventId: string | number; params: any }) => {
    try {
      const res = await eventPostsAPI.updateEventPost(eventId, params)
      return res
    } catch (error) {
      throw error
    }
  }
)

export const deleteEventPostAction = createAsyncThunk(
  'eventPosts/deleteEventPostAction',
  async (eventId: string | number) => {
    try {
      const res = await eventPostsAPI.deleteEventPost(eventId)
      return res
    } catch (error) {
      throw error
    }
  }
)

export const getAllEventAuthorsAction = createAsyncThunk(
  'eventPosts/getAllEventAuthorsAction',
  async (params?: any) => {
    try {
      const res = await eventPostsAPI.getAuthorAdmins(params)
      return res
    } catch (error) {
      throw error
    }
  }
)

export const uploadEventThumbnailAction = createAsyncThunk(
  'eventPosts/uploadEventThumbnailAction',
  async (file: File) => {
    try {
      const res = await eventPostsAPI.uploadMedia(file)
      return res
    } catch (error) {
      throw error
    }
  }
)

export const getRevenueEvent = createAsyncThunk(
  'eventPosts/getEventRevenue',
  async ({startDate, endDate} : {startDate?: string, endDate?: string}) => {
    try {
      const res = await eventPostsAPI.getRevenueEvent(startDate, endDate)
      return res
    } catch (error) {
      throw error
    }
  }
)

export const getIncomeEvent = createAsyncThunk(
  'eventPosts/getIncomeEvent',
  async ({startDate, endDate} : {startDate?: string, endDate?: string}) => {
    try {
      const res = await eventPostsAPI.getIncomeEvent(startDate, endDate)
      return res
    } catch (error) {
      throw error
    }
  }
)

export const getListTicket = createAsyncThunk(
  'eventPosts/getListTicket',
  async ({guid} : {guid: string}) => {
    try {
      const res = await eventPostsAPI.getListTicket(guid)
      return res
    } catch (error) {
      throw error
    }
  }
)
